import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
/* import { useAuth0 } from '@auth0/auth0-react'; */
import { api } from '../services/api';
import CheckAnimation from '../components/CheckAnimation';
import { CircularProgress, Tooltip, IconButton } from "@mui/material";
import { Replay, FileDownloadOutlined } from "@mui/icons-material";
import { config } from '../services/config';
import { downloadTicketPDF } from '../components/perfil/Compras/api';
import { updateTicketImage } from '../views/eventos/ticket/api';
import NotDesign from '../assets/design-not-available.png';
import Loading from '../components/Loading';
import Unauthorized from '../components/ProtectedRoutes/Unauthorized';
import { useAuth } from "../components/context/AuthContext";
const apiOrigin = config.URL_API;

const PaymentSuccess = () => {
  const { isAuthenticated, user } = useAuth();
  const history = useHistory();
  const urlParams = new URLSearchParams(window.location.search);
  const reference = urlParams.get('ref');

  const [paymentData, setPaymentData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [refreshingTickets, setRefreshingTickets] = useState({});
  const [downloadingTickets, setDownloadingTickets] = useState({});
  const [expandedImage, setExpandedImage] = useState(null);
  const [isUnauthorized, setIsUnauthorized] = useState(false);

  const getTicketImageUrl = (ticketId) => {
    return `${apiOrigin}/static/eventos/tickets/ticket${ticketId}.png?t=${Date.now()}`;
  };

  const handleRefreshTicketImage = async (e, ticketId, eventoId) => {
    e.stopPropagation();
    e.preventDefault();

    try {
      setRefreshingTickets(prev => ({ ...prev, [ticketId]: true }));
      await updateTicketImage(eventoId, ticketId);

      setTimeout(() => {
        fetchPaymentStatus();
        setRefreshingTickets(prev => ({ ...prev, [ticketId]: false }));
      }, 1500);

    } catch (error) {
      console.error('Error al actualizar la imagen del ticket:', error);
      setRefreshingTickets(prev => ({ ...prev, [ticketId]: false }));
    }
  };

  const handleDownload = async (e, ticketId) => {
    if (!ticketId) return;

    e.stopPropagation();
    e.preventDefault();

    try {
      setDownloadingTickets(prev => ({ ...prev, [ticketId]: true }));

      const pdfBlob = await downloadTicketPDF(ticketId);
      const url = window.URL.createObjectURL(pdfBlob);

      const eventoNombre = evento?.nombre || evento?.evento || 'evento';
      const ticketInfo = tickets?.find(t => t.id === ticketId);
      const ticketTipo = ticketInfo?.Tarifa?.concepto || 'ticket';

      const fileName = `${eventoNombre.replace(/\s+/g, '_')}_${ticketTipo.replace(/\s+/g, '_')}_${ticketId}.pdf`;

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();

      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);

    } catch (error) {
      console.error('Error al descargar el ticket:', error);
    } finally {
      setDownloadingTickets(prev => ({ ...prev, [ticketId]: false }));
    }
  };

  const handleExpandImage = (ticketId) => {
    setExpandedImage(ticketId);
  };

  const handleCloseImage = () => {
    setExpandedImage(null);
  };


  const fetchPaymentStatus = async () => {
    try {
      const response = await api.pvs.getStatusPayment(reference);
      if (response && response.compra) {
        setPaymentData(response);
        setError(null);
        setIsUnauthorized(false);
        return true;
      } else {
        setError(response.error || 'Error obteniendo estado del pago');
        return false;
      }
    } catch (error) {
      console.error('PVS Fetch Error:', error);
      if (error.status === 403 || error.message?.includes('Acceso denegado')) {
        setIsUnauthorized(true);
        setError(null);
      } else if (error.status === 404) {
        setError('Referencia de pago no encontrada en PVS');
      } else {
        setError(error.message || 'Error obteniendo estado del pago desde PVS');
      }
      return false;
    }
  };

  const fetchClickMacroPaymentStatus = async () => {
    try {
      const response = await api.clickmacro.getPaymentStatus(reference);
      console.log('ClickMacro Response:', response);

      if (response && response.status === 'success') {
        setPaymentData(response);
        setError(null);
        setIsUnauthorized(false);
        return true;
      } else {
        setError(response.error || response.message || 'Error obteniendo estado del pago');
        return false;
      }
    } catch (error) {
      console.error('ClickMacro Fetch Error:', error);
      if (error?.status === 403) {
        setIsUnauthorized(true);
      }
      setError('No se encontró el pago en ClickMacro');
      return false;
    }
  };

  const fetchAllPaymentStatus = async () => {
    setLoading(true);
    setError(null);

    let clickMacroSuccess = false;
    try {
      clickMacroSuccess = await fetchClickMacroPaymentStatus();
    } catch (error) {
      console.log('ClickMacro falló, intentando con PVS...');
      clickMacroSuccess = false;
    }

    if (!clickMacroSuccess) {
      try {
        await fetchPaymentStatus();
      } catch (error) {
        console.error('Ambos sistemas fallaron:', error);
        setError('No se pudo obtener la información del pago desde ningún sistema');
      }
    }

    setLoading(false);
  };

  useEffect(() => {
    if (!reference) {
      setError('No se proporcionó referencia de pago');
      setLoading(false);
      return;
    }

    fetchAllPaymentStatus();

    // Polling opcional para pagos pendientes
    /* const interval = setInterval(() => {
      if (paymentData?.recibo?.estado === 'PENDIENTE' || 
          paymentData?.recibo?.estado === 'PENDING') {
        fetchAllPaymentStatus();
      }
    }, 10000);

    return () => clearInterval(interval); */
  }, [reference]);

  if (loading) {
    return <Loading />;
  }

  if (isUnauthorized) {
    return <Unauthorized />;
  }

  if (error) {
    return (
      <div className="min-h-screen d-flex justify-content-center align-items-center"
        style={{ backgroundColor: "#E6E6FF" }}>
        <div className="text-center">
          <h2 style={{ color: "#0b0062", marginBottom: "20px" }}>Error</h2>
          <p style={{ color: "#6C757D", fontSize: "18px", marginBottom: "30px" }}>{error}</p>
          <button
            className="btn btn-primary"
            onClick={() => fetchAllPaymentStatus()}
            style={{ backgroundColor: "#5656FF", borderColor: "#5656FF" }}
          >
            Reintentar
          </button>
        </div>
      </div>
    );
  }

  if (!paymentData) {
    return (
      <div className="min-h-screen d-flex justify-content-center align-items-center"
        style={{ backgroundColor: "#E6E6FF" }}>
        <div className="text-center">
          <h2 style={{ color: "#0b0062" }}>No se encontraron datos del pago</h2>
        </div>
      </div>
    );
  }

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';

    const date = new Date(dateString);
    return new Intl.DateTimeFormat('es-AR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    }).format(date);
  };

  const { compra, recibo, evento, tickets, vouchers, can_download } = paymentData;

  const eventoNombre = evento?.nombre || evento?.evento || 'Evento';

  return (
    <div className="min-h-screen" style={{ backgroundColor: "#E6E6FF", width: "100%", height: "100%", paddingTop: "4%" }}>
      <div>
        <div style={{ backgroundColor: "#ffff", borderRadius: "8px", margin: "12%", marginTop: "0", padding: "30px", marginLeft: "5%", marginRight: "5%" }}>
          <div className='d-flex flex-column justify-content-center align-items-center mb-4'>
            <CheckAnimation />
            <p style={{
              color: "#0b0062",
              fontWeight: "600",
              fontSize: "clamp(24px, 5vw, 38px)",
              textAlign: "center",
              marginBottom: "5px"
            }}>¡Compra realizada!</p>
            <span style={{
              color: "#6C757D",
              fontSize: "clamp(16px, 3vw, 16px)",
              textAlign: "center",
              maxWidth: "100%",
              padding: "0 10px"
            }}>Gracias por tu compra {(user?.nombre + " " +user?.apellido) || 'Usuario'}. Aqui está tu información de compra para <span style={{ fontWeight: "600" }}>{eventoNombre}</span></span>
          </div>
          <div className='d-flex flex-column flex-wrap mt-4' style={{
            padding: "0 16px",
          }}>
            <p style={{
              color: "#0b0062",
              fontSize: "clamp(18px, 4vw, 22px)",
              fontWeight: "600",
              marginBottom: "16px"
            }}>
              Detalles de tu compra
            </p>

            <div className="row g-3 mb-4">

              {/* Evento */}
              <div className="col-12 col-md-6">
                <div className="" >
                  <p className='mb-1' style={{
                    fontWeight: "600",
                    color: "#0b0062",
                    fontSize: "16px"
                  }}>Evento</p>
                  <p className='mb-0' style={{
                    color: "#495057",
                    fontSize: "15px",
                    wordBreak: "break-word"
                  }}>{eventoNombre}</p>
                </div>
              </div>

              {/* Monto */}
              <div className="col-12 col-md-6">
                <div className="" >
                  <p className='mb-1' style={{
                    fontWeight: "600",
                    color: "#0b0062",
                    fontSize: "16px"
                  }}>Monto total</p>
                  <p className='mb-0' style={{
                    color: "#495057",
                    fontSize: "15px",
                    fontWeight: "600"
                  }}>$ {recibo?.monto}</p>
                </div>
              </div>

              {/* Fecha */}
              <div className="col-12 col-md-6">
                <div className="" >
                  <p className='mb-1' style={{
                    fontWeight: "600",
                    color: "#0b0062",
                    fontSize: "16px"
                  }}>Fecha de compra</p>
                  <p className='mb-0' style={{
                    color: "#495057",
                    fontSize: "15px"
                  }}>{formatDate(compra?.fecha || recibo?.fecha_aprobacion)}</p>
                </div>
              </div>

              {/* N° de referencia */}
              <div className="col-12 col-md-6">
                <div className="" >
                  <p className='mb-1' style={{
                    fontWeight: "600",
                    color: "#0b0062",
                    fontSize: "16px"
                  }}>N° de referencia</p>
                  <p className='mb-0' style={{
                    color: "#495057",
                    fontSize: "16px",
                    fontFamily: "monospace",
                    wordBreak: "break-all"
                  }}>{compra?.external_reference || recibo?.referencia || 'N/A'}</p>
                </div>
              </div>

              {/* N° de compra */}
              <div className="col-12 col-md-6">
                <div className="" >
                  <p className='mb-1' style={{
                    fontWeight: "600",
                    color: "#0b0062",
                    fontSize: "16px"
                  }}>N° de compra</p>
                  <p className='mb-0' style={{
                    color: "#495057",
                    fontSize: "16px",
                    fontFamily: "monospace"
                  }}>{compra?.id || 'N/A'}</p>
                </div>
              </div>

              {/* N° de transacción */}
              <div className="col-12 col-md-6">
                <div className="" >
                  <p className='mb-1' style={{
                    fontWeight: "600",
                    color: "#0b0062",
                    fontSize: "16px"
                  }}>N° de transacción</p>
                  <p className='mb-0' style={{
                    color: "#495057",
                    fontSize: "16px",
                    fontFamily: "monospace",
                    wordBreak: "break-all"
                  }}>{recibo?.transaccion_id}</p>
                </div>
              </div>

            </div>
          </div>

          <div style={{ padding: "0 16px" }}>
            <p style={{ color: "#0b0062", fontSize: "22px", fontWeight: "600", marginBottom: "8px" }}>Tickets</p>
            <p style={{ color: "#6C757D", fontSize: "16px" }}>
              Tus tickets ya están disponibles. Te los mandamos por correo
              {tickets?.length > 0 && ", pero también podés descargarlos desde acá"}.
              <br />Recordá tenerlos a mano para mostrarlos al ingresar al evento.
              <br />También podés volver a verlos en <a href="/mis-compras" style={{ color: "#5656ff", fontWeight: "600" }}>Mis compras</a>
            </p>
            <div>
              {can_download && tickets && tickets?.length > 0 && (
                <div className="row g-3 justify-content-center mt-2">
                  {tickets.map((ticket) => (
                    <div key={ticket.id} className="col-12 col-sm-6 col-lg-4">
                      <div
                        className="card h-100"
                        style={{
                          borderRadius: "12px",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                          overflow: 'hidden',
                          cursor: 'pointer',
                          transition: 'transform 0.2s ease',
                          border: "1px solid #e9ecef"
                        }}
                        onClick={() => handleExpandImage(ticket.id)}
                        onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
                        onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
                      >
                        {/* Imagen del ticket */}
                        <div style={{ position: 'relative' }}>
                          <img
                            src={getTicketImageUrl(ticket.id)}
                            alt={`Ticket ${ticket.id}`}
                            style={{
                              width: "100%",
                              height: "200px",
                              objectFit: "contain",
                              display: "block",
                            }}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = NotDesign;
                            }}
                          />

                          <Tooltip title="Actualizar diseño del ticket" arrow>
                            <IconButton
                              size="small"
                              onClick={(e) => handleRefreshTicketImage(e, ticket.id, evento?.id)}
                              style={{
                                position: 'absolute',
                                top: '8px',
                                right: '8px',
                                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                color: refreshingTickets[ticket.id] ? '#5656FF' : '#6B7280',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
                              }}
                            >
                              {refreshingTickets[ticket.id] ? (
                                <CircularProgress size={16} style={{ color: '#5656FF' }} />
                              ) : (
                                <Replay fontSize="small" />
                              )}
                            </IconButton>
                          </Tooltip>

                          {refreshingTickets[ticket.id] && (
                            <div style={{
                              position: 'absolute',
                              top: 0,
                              left: 0,
                              width: '100%',
                              height: '100%',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              backgroundColor: 'rgba(255, 255, 255, 0.8)',
                            }}>
                              <CircularProgress size={30} style={{ color: '#5656FF' }} />
                            </div>
                          )}
                        </div>

                        {/* Body de la card */}
                        <div className="card-body  d-flex flex-column">
                          <h6 style={{
                            fontWeight: 600,
                            color: '#0B0060',
                            marginBottom: '8px',
                            fontFamily: "Bricolage Grotesque",
                            fontSize: 'clamp(16px, 3vw, 16px)',
                            lineHeight: '1.3'
                          }}>
                            {eventoNombre}
                          </h6>

                          <p style={{
                            color: '#6c757d',
                            margin: '0 0 12px 0',
                            fontSize: 'clamp(12px, 2.5vw, 16px)',
                            fontWeight: 500,
                            fontFamily: "Bricolage Grotesque"
                          }}>
                            {ticket?.Tarifa?.concepto || ticket?.tarifa?.concepto || 'Ticket'}
                          </p>

                          <div style={{
                            marginBottom: '16px',
                            fontSize: 'clamp(11px, 2.5vw, 13px)',
                            color: '#6c757d'
                          }}>
                            <strong>Titular:</strong> {ticket.nombre} {ticket.apellido}
                          </div>

                          {/* Botón de descarga */}
                          <div className="mt-auto">
                            <button
                              type="button"
                              onClick={(e) => handleDownload(e, ticket.id)}
                              className="btn w-100"
                              style={{
                                border: "2px solid #5656FF",
                                color: "#5656FF",
                                padding: "10px 12px",
                                borderRadius: "8px",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: "clamp(12px, 2.5vw, 16px)",
                                fontWeight: "600",
                                opacity: downloadingTickets[ticket.id] ? 0.7 : 1,
                                transition: 'all 0.2s ease'
                              }}
                              onMouseEnter={(e) => {
                                if (!downloadingTickets[ticket.id]) {
                                  e.target.style.backgroundColor = '#5656FF';
                                  e.target.style.color = 'white';
                                }
                              }}
                              onMouseLeave={(e) => {
                                if (!downloadingTickets[ticket.id]) {
                                  e.target.style.backgroundColor = 'transparent';
                                  e.target.style.color = '#5656FF';
                                }
                              }}
                            >
                              {downloadingTickets[ticket.id] ? (
                                <>
                                  <CircularProgress size={14} style={{ color: '#5656FF', marginRight: "6px" }} />
                                  Descargando...
                                </>
                              ) : (
                                <>
                                  <FileDownloadOutlined fontSize="small" style={{ marginRight: "6px" }} />
                                  Descargar PDF
                                </>
                              )}
                            </button>
                          </div>

                          <div style={{
                            marginTop: '12px',
                            textAlign: 'center',
                            fontSize: 'clamp(10px, 2vw, 11px)',
                            color: '#adb5bd',
                            fontFamily: "Bricolage Grotesque"
                          }}>
                            <span>ID: {ticket.id}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Modal para imagen expandida */}
      {
        expandedImage && (
          <div
            className="modal d-block"
            style={{
              backgroundColor: 'rgba(0,0,0,0.8)',
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              zIndex: 1050
            }}
            onClick={handleCloseImage}
          >
            <div className="d-flex justify-content-center align-items-center h-100 ">
              <img
                src={getTicketImageUrl(expandedImage)}
                alt={`Ticket expandido ${expandedImage}`}
                style={{
                  maxWidth: '90%',
                  maxHeight: '90%',
                  objectFit: 'contain',
                  boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
                  borderRadius: '8px'
                }}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = NotDesign;
                }}
              />
            </div>
            <div
              style={{
                position: 'absolute',
                bottom: '20px',
                left: '50%',
                transform: 'translateX(-50%)',
                color: 'white',
                fontSize: '16px',
                textAlign: 'center',
                fontFamily: "Bricolage Grotesque",
                textShadow: '0 2px 4px rgba(0,0,0,0.5)'
              }}
            >
              (Haz clic en cualquier lugar para cerrar)
            </div>
          </div>
        )
      }
    </div >
  );
};

export default PaymentSuccess;